import React from 'react'

import { MdWarning } from 'react-icons/md'
import styled from '@emotion/styled'
import { Flex } from './system'
import {
  space,
  color,
  maxWidth,
  height,
  flex,
  borders,
  order,
  alignSelf,
  fontSize,
  fontFamily,
  fontWeight,
  letterSpacing,
  borderRadius,
  borderColor,
} from 'styled-system'

const themed = key => props => props.theme[key]

const BadgeBase = styled(Flex)(
  {
    display: 'inline-flex',
    textTransform: 'uppercase',
    position: 'relative',
  },
  space,
  height,
  fontSize,
  fontFamily,
  fontWeight,
  color,
  flex,
  order,
  alignSelf,
  maxWidth,
  borders,
  letterSpacing,
  borderRadius,
  borderColor,
  themed(`Flex`)
)

BadgeBase.propTypes = {
  ...space.propTypes,
  ...height.propTypes,
  ...fontSize.propTypes,
  ...fontFamily.propTypes,
  ...fontWeight.propTypes,
  ...color.propTypes,
  ...flex.propTypes,
  ...order.propTypes,
  ...alignSelf.propTypes,
  ...borders.propTypes,
  ...letterSpacing.propTypes,
  ...borderRadius.propTypes,
  ...borderColor.propTypes,
}

BadgeBase.defaultProps = {
  bg: `yellow.100`,
  color: 'yellow.900',
  py: 1,
  px: 2,
  fontSize: 0,
  fontFamily: 'sansSerif',
  lineHeight: 'solid',
  border: 1,
  borderColor: 'yellow.100',
  letterSpacing: 'tracked',
  alignItems: 'center',
  borderRadius: 5,
  fontWeight: 0,
}

const Badge = ({ children, ...rest }) => (
  <BadgeBase {...rest}>
    {children}
    <MdWarning style={{ fontSize: 16, marginLeft: '0.25rem' }} />
  </BadgeBase>
)

export default Badge
